import { computed, inject, Injectable, InjectionToken, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { EMPTY } from 'rxjs';
import { FilterEngineOptions, FilterEngineSettings } from '../models';
import { AbstractUserPreferencesFavoriteFilterEngineService } from './abstract-user-preferences-favorite-filter-engine.service';

export const FILTER_ENGINE_V2_SETTINGS = new InjectionToken<FilterEngineSettings>('FILTER_ENGINE_V2_SETTINGS');

@Injectable({ providedIn: 'root' })
export class FilterEngineSettingsService {
  private readonly filterEngineSettings = inject(FILTER_ENGINE_V2_SETTINGS, { optional: true });
  readonly options: Signal<FilterEngineOptions> = computed(() => {
    // Trigger reactivity
    this.account();
    this.userPreferences();
    return this.filterEngineSettings?.options as FilterEngineOptions;
  });
  private readonly userPreferencesService = inject(AbstractUserPreferencesFavoriteFilterEngineService, { optional: true });
  readonly account: Signal<UserAccount | undefined> = toSignal(
    this.userPreferencesService?.getAccount$()?.pipe(takeUntilDestroyed()) ?? EMPTY,
    { initialValue: undefined }
  );
  readonly userPreferences: Signal<UserPreferences | undefined> = toSignal(
    this.userPreferencesService?.getUserPreferences$()?.pipe(takeUntilDestroyed()) ?? EMPTY,
    { initialValue: undefined }
  );

  saveUserPreferences(preferences: UserPreferences): void {
    this.userPreferencesService?.saveUserPreferences(preferences);
  }
}
